module.exports = __webpack_public_path__ + "img/ski_cos8.f8dc3dac.png";